import { IGetStudentPaginatedRosterData, IGetStudentTestStatusData } from '../apollo/types';
import { mergeStudentStatuses } from '../components/digital/testDayLive/roster/helper';
import { generateStudentsDisplayValues } from '../components/digital/students/roster/helper';

export type BuildStudentsDisplayValue = IGetStudentPaginatedRosterData &
  Partial<Pick<IGetStudentTestStatusData, 'examStartTime' | 'estimatedExamEndTime'>>;

export function buildStudentsDisplayValues(
  allStudents: IGetStudentPaginatedRosterData[],
  studentsTestStatuses: IGetStudentTestStatusData[],
  orgEvent: { tdtkAsmtType: string } | undefined
): BuildStudentsDisplayValue[] {
  if (!orgEvent) {
    return [];
  }

  const mergedStudents = mergeStudentStatuses(allStudents, studentsTestStatuses);
  return generateStudentsDisplayValues(mergedStudents, orgEvent) as BuildStudentsDisplayValue[];
}
